import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Monitor, Cpu, Palette } from 'lucide-react';
const services = [{
  icon: Monitor,
  title: 'Individuelle Software',
  features: ['Web-Anwendungen', 'Desktop-Software', 'Mobile Apps', 'Cloud-Lösungen']
}, {
  icon: Cpu,
  title: 'IIoT & Digitalisierung',
  features: ['Maschinendatenerfassung', 'Schnittstellen & APIs', 'Automatisierung', 'Sensorik-Integration']
}, {
  icon: Palette,
  title: 'UI/UX Design',
  features: ['Intuitive Bedienung', 'Praxisnahe Interfaces', 'Prototyping', 'User Testing']
}];
export function ServicesSlide() {
  return <SlideWrapper variant="dark" data-id="element-181">
      <div className="h-full flex flex-col justify-center" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16" data-id="element-183">
          <h2 className="text-5xl font-bold text-white mb-4" data-id="element-184">
            Unsere Leistungen
          </h2>
          <div className="h-1 w-24 bg-accent rounded-full" data-id="element-185" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.2,
          duration: 0.6
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-187">
              <div className="w-14 h-14 bg-accent/20 rounded-xl flex items-center justify-center mb-6 text-accent" data-id="element-188">
                <service.icon className="w-8 h-8" data-id="element-189" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-190">
                {service.title}
              </h3>
              <ul className="space-y-3" data-id="element-191">
                {service.features.map((feature, i) => <li key={i} className="flex items-center text-gray-300" data-id="element-192">
                    <span className="w-1.5 h-1.5 bg-accent rounded-full mr-3" data-id="element-193" />
                    {feature}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}